import React, { useState } from "react";
import { Slider } from "@blueprintjs/core";
import { types } from "../../lib/store";
import { useStoreState, useStoreActions } from "easy-peasy";

import {useTranslation} from "react-i18next";

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;

  return (<Slider.Handle value={value} {...restProps}>{value} Hz</Slider.Handle>)
};

const FrequencySlider = () => {
  const { t } = useTranslation();
  const fan = useStoreState(state => state.selection.fan);

  const storeFrequency = useStoreState(
    state => state.selection.designPoint.frequency
  );

  const { min_frequency, max_frequency } = useStoreState(
    state => state.selection.fan.simulation
  );

  const updateCustomFrequency = useStoreActions(
    actions => actions.selection[types.SET_CUSTOM_FREQUENCY]
  );

  const [currentFrequency, setCurrentFrequency] = useState(storeFrequency);

  const updateStore = (value) => {
    updateCustomFrequency(value);
  };

  const renderLabel = (val, event) => {
    if(val === fan.frequency && !event.isHandleTooltip) {
      return `${val}Hz *`
    }
    return `${val}Hz`;
  }

  return (
    <div style={{padding: "20px 20px 0 20px"}}>
      <Slider
        min={min_frequency}
        max={max_frequency}
        stepSize={1}
        onChange={(value) => setCurrentFrequency(value)}
        onRelease={updateStore}
        labelRenderer={renderLabel}
        labelValues={[min_frequency, fan.frequency, max_frequency]}
        showTrackFill={false}
        value={currentFrequency}
      />
      <div style={{fontSize: "11px", float: 'right', marginRight: "-20px"}}> * {t("frontend:fan.simulation.original_frequency")}</div>
    </div>
  );
};

export default FrequencySlider;
